import React, { useState } from "react";
import { useTranslation } from "react-i18next";
//Components
import { MainContainer, ManagementDiv, SaveAndCancelDiv, SaveButton, CancelButton } from "./styles";
import ButtonWithIcon from "../../../buttonWithIcon";
import ButtonTransparentWithIcon from "../../../buttonTransparentWithIcon";
import Popup from "../../../popup";
import DeletePatient from "../deletePatient";
// Assets
import EditUserImg from "../../../../assets/btn_edit_user.svg";
import DeleteUserImg from "../../../../assets/btn_delete_user.svg";

const ActionsManagement = ({ handleSubmit, disabledInputs, setDisabledInputs, patientId, patientVersion }) => {
  const [isShowDeletePatient, setIsShowDeletePatient] = useState(false);
  const [t] = useTranslation("global");

  const handleAvailableData = (e) => {
    e.preventDefault();
    setDisabledInputs(false);
  };
  const handleDisabledData = (e) => {
    e.preventDefault();
    window.location.reload();
  };
  const handleShowDeletePatient = (e) => {
    e.preventDefault();
    setIsShowDeletePatient(true);
  };

  const renderShowDeletePatient = () => {
    if (disabledInputs) {
      return (
        <ManagementDiv justifyContent="flex-start">
          <ButtonWithIcon icon={EditUserImg} name={t("editPatient.editPatientButton")} onClick={handleAvailableData} />
        </ManagementDiv>
      );
    } else {
      return (
        <ManagementDiv justifyContent="space-between">
          <SaveAndCancelDiv>
            <SaveButton onClick={handleSubmit}>{t("editPatient.saveButton")}</SaveButton>
            <CancelButton onClick={handleDisabledData}>{t("editPatient.cancelButton")}</CancelButton>
          </SaveAndCancelDiv>
          <ButtonTransparentWithIcon
            icon={DeleteUserImg}
            name={t("editPatient.deletePatientButton")}
            onClick={handleShowDeletePatient}
          />
          <Popup isShowed={isShowDeletePatient} setIsShowed={setIsShowDeletePatient}>
            <DeletePatient
              setIsShowDeletePatient={setIsShowDeletePatient}
              patientId={patientId}
              patientVersion={patientVersion}
            />
          </Popup>
        </ManagementDiv>
      );
    }
  };

  return <MainContainer>{renderShowDeletePatient()}</MainContainer>;
};

export default ActionsManagement;
